<template>
  <div class="sidebar">
    <qd-collapse class="is-pulled-left is-marginless">
      <aside class="columns is-multiline is-paddingless is-marginless" >
        <div class="is-sidebar-menu">
        <div class="column menuColor center is-paddingless"
             :class="{'menuColorSelect': gestcomMenu}">
          <a @click="setGestcomMenu(!gestcomMenu);"
             class="has-text-weight-bold">
          <img src='/static/img/Gestion%20commerciale.svg'
          class="iconMenu"/>
            <div>
              {{ $t('sidebar.module.gestcom')}}
            </div>
          </a>
        </div>
          <div class="mgt-20px"></div>
          <div class="column menuColor has-text-weight-bold center is-paddingless"
               :class="{'menuColorSelect': patrimoineMenu}">
            <a @click="setPatrimoineMenu(!patrimoineMenu);"
               class="has-text-weight-bold">
            <img src="@/assets/img/Patrimoine.svg"
                 class="iconMenu"/>
              <p class="is-size-7">
                {{ $t('sidebar.module.patrimoine')}}
              </p>
            </a>
          </div>
          <div class="mgt-20px"></div>
          <div class="column menuColor has-text-weight-bold center is-paddingless"
               :class="{'menuColorSelect': bauxMenu}">
            <a @click="setBauxMenu(!bauxMenu);"
               class="has-text-weight-bold">
              <img src="/static/img/Baux.svg"
                   class="iconMenu"/>
              <p class="is-size-7">
                {{ $t('sidebar.module.baux')}}
              </p>
            </a>
          </div>
          <div class="mgt-20px"></div>
          <div class="column menuColor has-text-weight-bold center is-paddingless"
               :class="{'menuColorSelect': logisticMenu}">
            <a @click="setLogisticMenu(!logisticMenu)"
               class="has-text-weight-bold">
              <img src="@/assets/img/Logistique.svg"
                   class="iconMenu"/>
              <p class="is-size-7">
                {{ $t('sidebar.module.logistique')}}
              </p>
            </a>
          </div>
          <div class="mgt-20px"></div>
          <div class="column menuColor center is-paddingless has-text-weight-bold"
               :class="{'menuColorSelect': comptaMenu}">
            <a @click="setComptaMenu(!comptaMenu)"
               class="has-text-weight-bold">
              <img src='@/assets/img/Comptabilite.svg'
                   class="iconMenu"/>
              <p class="is-size-7">
                {{ $t('sidebar.module.comptabilite')}}
              </p>
            </a>
          </div>
          <div class="mgt-20px"></div>
          <div
            class="column menuColor center is-paddingless has-text-weight-bold mgt-20px"
            :class="{'menuColorSelect': achatMenu}">
            <a @click="setAchatMenu(!achatMenu)"
               class="has-text-weight-bold">
              <img src='/static/img/Achat.svg'
                   class="iconMenu"/>
              <p class="is-size-7">
                {{ $t('sidebar.module.achat')}}
              </p>
            </a>
          </div>
          <div v-if="moduleStockActive"
            class="column menuColor center is-paddingless has-text-weight-bold mgt-20px"
            :class="{'menuColorSelect': stockMenu}">
            <a @click="setStockMenu(!stockMenu)"
               class="has-text-weight-bold">
              <img src='/static/img/Stock.svg'
                   class="iconMenu"/>
              <p class="is-size-7">
                {{ $t('sidebar.module.stock')}}
              </p>
            </a>
          </div>
        </div>
        <div class="is-sidebar-subMenu" v-if="gestcomMenu">
          <app-gest-com-submenu></app-gest-com-submenu>
        </div>
        <div class="is-sidebar-subMenu" v-if="patrimoineMenu">
          <app-patrimoine></app-patrimoine>
        </div>
        <div class="is-sidebar-subMenu" v-if="bauxMenu">
          <app-baux></app-baux>
        </div>
        <div class="is-sidebar-subMenu" v-if="logisticMenu">
          <app-logistique></app-logistique>
        </div>
        <div class="is-sidebar-subMenu" v-if="comptaMenu">
          <app-comptabilite></app-comptabilite>
        </div>
        <div class="is-sidebar-subMenu" v-if="achatMenu">
          <app-achat></app-achat>
        </div>
        <div class="is-sidebar-subMenu" v-if="stockMenu">
          <app-stock-menu></app-stock-menu>
        </div>
      </aside>
    </qd-collapse>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import AppGestComSubmenu from '@/components/sideBar/submenuSidebar/gestCom';
import AppPatrimoine from '@/components/sideBar/submenuSidebar/patrimoine';
import AppComptabilite from '@/components/sideBar/submenuSidebar/comptabilite';
import AppLogistique from '@/components/sideBar/submenuSidebar/logistique';
import AppBaux from '@/components/sideBar/submenuSidebar/baux';
import AppAchat from '@/components/sideBar/submenuSidebar/achatMenu';
import AppStockMenu from '@/components/sideBar/submenuSidebar/stockMenu';

import {
  SET_BAUX_MENU,
  SET_COMPTA_MENU,
  SET_GESTCOM_MENU, SET_INDEX_SUB_MENU_OPEN,
  SET_LOGISTIC_MENU,
  SET_PATRIMOINE_MENU,
  SET_ACHAT_MENU,
  SET_STOCK_MENU,
} from '@/store/modules/menu/menu-mutation-type';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';

const menu = createNamespacedHelpers('menu');
const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'app-sidebar',
  components: {
    AppGestComSubmenu,
    AppPatrimoine,
    AppComptabilite,
    AppLogistique,
    AppBaux,
    AppAchat,
    AppStockMenu,
  },
  data() {
    return {
    };
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...menu.mapMutations({
      setPatrimoineMenu: SET_PATRIMOINE_MENU,
      setGestcomMenu: SET_GESTCOM_MENU,
      setLogisticMenu: SET_LOGISTIC_MENU,
      setComptaMenu: SET_COMPTA_MENU,
      setIndexSubMenu: SET_INDEX_SUB_MENU_OPEN,
      setBauxMenu: SET_BAUX_MENU,
      setAchatMenu: SET_ACHAT_MENU,
      setStockMenu: SET_STOCK_MENU,
    }),
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...menu.mapGetters({
      gestcomMenu: 'gestcomMenu',
      patrimoineMenu: 'patrimoineMenu',
      logisticMenu: 'logisticMenu',
      comptaMenu: 'comptaMenu',
      bauxMenu: 'bauxMenu',
      achatMenu: 'achatMenu',
      stockMenu: 'stockMenu',
    }),
    moduleStockActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>
</style>
